import { TabProgetto } from "./tab-progetto.model";

export class ModifyProgettoINModel {
    tabProgetto: TabProgetto
}